import SkillsTable from '../components/SkillsTable/SkillsTable';

const Skills = () => {
  return <SkillsTable />;
};

export default Skills;
